import { toPng } from 'html-to-image';
import { jsPDF } from 'jspdf';

// A4 in millimetres (jsPDF 'a4' portrait).
const A4_W = 210;
const A4_H = 297;

/**
 * Render an invoice element to a (possibly multi-page) A4 PDF and save it.
 *
 * If `root` contains one or more `[data-invoice-page]` children (as produced by
 * ConsumableInvoiceDocument when an invoice spans multiple pages), each becomes a
 * separate PDF page. Otherwise the whole `root` is captured as a single page — so
 * existing single-page invoices are unaffected.
 */
export async function downloadInvoicePDF(root: HTMLElement, filename: string): Promise<void> {
  const pageEls = Array.from(root.querySelectorAll<HTMLElement>('[data-invoice-page]'));
  const targets = pageEls.length > 0 ? pageEls : [root];

  const pdf = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
  for (let i = 0; i < targets.length; i++) {
    if (i > 0) pdf.addPage();
    const dataUrl = await toPng(targets[i], { pixelRatio: 2, backgroundColor: '#ffffff', cacheBust: true });
    pdf.addImage(dataUrl, 'PNG', 0, 0, A4_W, A4_H);
  }
  pdf.save(filename);
}
